export default "__VITE_ASSET__BPrNOVia__"